import React from 'react'
import Title from '../Title/Index'
import '../Aboutus/aboutus.css'
import ImageTag from '../ImageTag/Index'


const Index = ({Data}) => {
  return (
    <>
        <section className='w-full flex flex-wrap p-100 mobileContainer pt-0'  data-aos="fade-up"
          data-aos-offset="200"
          data-aos-duration="500"
          data-aos-once="true"
          data-aos-easing="ease-in-sine">  
          <div className='w-full lg:w-[900px] m-auto'>
          <Title firstHeading={Data.heading} secondHeading={Data.title} subTitle={Data.descp}/>
          </div>
    <div className='w-full flex flex-wrap justify-content-end md:gap-10 gap-3 align-items-center flex-direction-mobile'>
             <div className='w-full xl:w-1/3 flex flex-wrap'>
             <ul className='listItems' data-aos="fade-up"
          data-aos-offset="200"
          data-aos-duration="500"
          data-aos-once="true"
          data-aos-easing="ease-in-sine">
             {Data.features.map((items, index) => 
              <li key={index}>{items}</li>
            )}
               </ul>
             </div>
             <div className='w-full xl:w-1/2'>
                  <ImageTag ImagePath={Data.featureBanner} ImageClass={'float-end'}/>
             </div>
             </div>
          </section>   
   </>
  )
}

export default Index